const GUEST_DETAILS_INVALID = "Some guest details are missing or invalid.";

export const TABLE_REQUEST_ERROR_MESSAGES = {
  tables_unavailable: "Tables aren't available for this event.",
  party_too_small: "Add at least 3 guests to request a table.",
  duplicate_guest:
    "Each guest needs their own email and phone number, different from yours.",
  email_unavailable:
    "One of these email addresses can't be used. Try a different one.",
  already_ticketed:
    "Someone in your party already has a table ticket for this event.",
  open_request_exists: "You already have an open table request for this event.",
  missing_guest_field: GUEST_DETAILS_INVALID,
  invalid_fields: GUEST_DETAILS_INVALID,
  request_not_accepted: "This request hasn't been accepted yet.",
  offer_expired: "This offer has expired.",
  already_paid: "This table is already paid for.",
  table_unavailable:
    "This table is no longer available. Contact us and we'll help.",
  guest_already_ticketed:
    "Someone in your party already has a ticket for this table.",
  payment_unavailable:
    "We couldn't find this table's payment. Contact us and we'll help.",
};

const GENERIC_ERROR = "Something went wrong. Please try again.";
const SIGNED_OUT_STATUSES = [401, 403];

// party_too_large has no entry: its server detail names the largest table.
export const tableRequestErrorMessage = (error) => {
  if (SIGNED_OUT_STATUSES.includes(error?.response?.status)) {
    return "Please sign in again.";
  }
  const data = error?.response?.data;
  const mapped = data?.code ? TABLE_REQUEST_ERROR_MESSAGES[data.code] : null;
  if (mapped) return mapped;
  if (typeof data?.detail === "string" && data.detail) return data.detail;
  return GENERIC_ERROR;
};

const normalizeEmail = (value) => (value || "").trim().toLowerCase();
const phoneDigits = (value) => (value || "").replace(/\D/g, "");

/**
 * Why a guest's email or number cannot be used, or null. Guest numbers match
 * the form, where the requester is Guest 1.
 */
const contactConflict = (normalize, noun) => (value, index, guestValues, own) => {
  const key = normalize(value);
  if (!key) return null;
  if (own && key === normalize(own)) return `That's your ${noun}. Use your guest's own.`;
  const earlier = guestValues.slice(0, index).findIndex((other) => normalize(other) === key);
  return earlier >= 0 ? `Guest ${earlier + 2} already uses this ${noun}.` : null;
};

export const emailConflict = contactConflict(normalizeEmail, "email");
export const phoneConflict = contactConflict(phoneDigits, "number");

export const guestFieldErrors = (error) => {
  const data = error?.response?.data;
  const guests = data?.errors?.guests;
  if (!Array.isArray(guests)) return [];
  return guests.flatMap((fields, index) =>
    Object.entries(fields || {}).map(([field, messages]) => ({
      index,
      field,
      message: Array.isArray(messages) ? messages[0] : String(messages),
    })),
  );
};
